<template>
  <div>
    <span class="caption grey--text text--darken-1">
      {{component.label}}
    </span>
    <v-autocomplete
      :items="component.options || []"
      item-text="text"
      item-value="value"
      chips
      clearable
      :value="value"
      @input="value => $emit('input', value)"
      :filter="filter"
      :persistent-hint="valueHint"
      solo
      class="thin-border"
    >
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: undefined
    },
    valueHint: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {
    filter(item, queryText, itemText) {
      const normalizedDescription = itemText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const normalizedQueryText = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return (
        item.value.toLowerCase().includes(normalizedQueryText) ||
        normalizedDescription.includes(normalizedQueryText)
      )
    }
  }
}
</script>
